export enum NotificationDuration {
    Standard = 4,
    Long = 8
}